const state = {
  //分享数据信息
  shareData: {},
  // 分享id
  taskId: '',
  // 禁用的组件id
  diableColumns: [],
  // erp订单数据
  erpDataMap: [],
  // 查询分享配置
  watchConfig: {},
  // 关联子表单的查询数据
  conditionsLink: {},
  // 关联子表单的规则
  linkRules: [],
  // 关联子表单规则单条还是多条
  subtype:{},
  // 关联子表单规则是否强制填充  0 不填充 1 填充
  dataForceFill:{},
  // 关联子表单规则是否清空数据  0 不清空 1 清空
  dataForceClear:{},
  // 关联子表单自动拉取的值
  linkOtherValue:{},
  // 定制的工作表权限关联子表单
  linkChildRight:[],
  // 获取关联子表单的规则
  submitCheckRules: undefined,
};
const mutations = {
  //  获取分享的数据
  getShareId(state, obj) {
    state.shareData = obj
  },
  // 获取分享id
  getShareTask(state, obj) {
    state.taskId = obj.taskId
  },
  // 禁用的组件id
  getDisableColumns(state, arr) {
    state.diableColumns = arr
  },
  //储存erp订单列表
  SET_ERP_DATA_MAP(state, erpDataMap) {
    state.erpDataMap = erpDataMap
  },
  WATCH_CONFIG(state, obj) {
    state.watchConfig = obj
  },
  // 关联子表单的查询数据
  SET_CONDITIONS_DATA(state, obj) {
    state.conditionsLink = obj
  },
  // 关联子表单的规则
  SET_LINKRULES(state, obj) {
    state.linkRules = obj
  },
  // 关联子表单规则单条还是多条
  SET_SUBTYPE(state, obj) {
    state.subtype = obj
  },
  //  关联子表单规则是否强制填充  0 不填充 1 填充
  SET_DATAFORCEFILL(state, obj) {
    state.dataForceFill = obj
  },
  //  关联子表单规则是否清空数据  0 不清空 1 清空
  SET_DATAFORCECLEAR(state, obj) {
    state.dataForceClear = obj
  },
  // 关联子表单自动拉取的值
  SET_LINKOTHERVALUE(state, obj) {
    state.linkOtherValue = obj
  },
// 子表单的值
  SET_LINK_CHILD_RIGHT(state,obj){
    state.linkChildRight = obj
  },
  // 获取关联子表单的规则
  SET_SUBMIT_CHECK_RULES(state,obj){
    state.submitCheckRules = obj
  }
}
export default {
  namespaced: true,
  state,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/getShareInfo.js